__turbopack_context__.v({
  "barcode": "CartTicket-module__RVMtrq__barcode",
  "barcodeLine": "CartTicket-module__RVMtrq__barcodeLine",
  "barcodeLines": "CartTicket-module__RVMtrq__barcodeLines",
  "barcodeNumber": "CartTicket-module__RVMtrq__barcodeNumber",
  "cartItem": "CartTicket-module__RVMtrq__cartItem",
  "checkoutBtn": "CartTicket-module__RVMtrq__checkoutBtn",
  "closeBtn": "CartTicket-module__RVMtrq__closeBtn",
  "date": "CartTicket-module__RVMtrq__date",
  "divider": "CartTicket-module__RVMtrq__divider",
  "fadeIn": "CartTicket-module__RVMtrq__fadeIn",
  "footer": "CartTicket-module__RVMtrq__footer",
  "header": "CartTicket-module__RVMtrq__header",
  "itemActions": "CartTicket-module__RVMtrq__itemActions",
  "itemCount": "CartTicket-module__RVMtrq__itemCount",
  "itemHeader": "CartTicket-module__RVMtrq__itemHeader",
  "itemImageSmall": "CartTicket-module__RVMtrq__itemImageSmall",
  "itemInfo": "CartTicket-module__RVMtrq__itemInfo",
  "itemName": "CartTicket-module__RVMtrq__itemName",
  "itemPrice": "CartTicket-module__RVMtrq__itemPrice",
  "itemTotal": "CartTicket-module__RVMtrq__itemTotal",
  "itemsSection": "CartTicket-module__RVMtrq__itemsSection",
  "orderInfo": "CartTicket-module__RVMtrq__orderInfo",
  "overlay": "CartTicket-module__RVMtrq__overlay",
  "perforation": "CartTicket-module__RVMtrq__perforation",
  "priceRow": "CartTicket-module__RVMtrq__priceRow",
  "priceSection": "CartTicket-module__RVMtrq__priceSection",
  "quantity": "CartTicket-module__RVMtrq__quantity",
  "removeBtn": "CartTicket-module__RVMtrq__removeBtn",
  "storeName": "CartTicket-module__RVMtrq__storeName",
  "ticket": "CartTicket-module__RVMtrq__ticket",
  "ticketContainer": "CartTicket-module__RVMtrq__ticketContainer",
  "ticketContent": "CartTicket-module__RVMtrq__ticketContent",
  "total": "CartTicket-module__RVMtrq__total",
});
